import React from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

const SiteFooter = () => {

  return (
    <>
      <footer className="py-16 border-t border-border/30 bg-background">
        <div className="container px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl  flex items-center justify-center transition-shadow">
                <img src="/favicon.ico" className='rounded-full' alt="" />
              </div>
              <span className="font-semibold text-foreground tracking-tight">Syntimacy</span>
            </Link>

            <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-foreground/50">
              <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
              <Link to="/creators" className="hover:text-foreground transition-colors">For Creators</Link>
            </div>
            <div>
              <p className="text-sm text-foreground/40">
                © 2025 Syntimacy. All rights reserved.
              </p>
              <span className="font-semibold">Company info</span>
              <p className="text-sm text-foreground/40">
                Syntimacy LLC,
                <br />
                9424 Balm Riverview Rd,
                <br />
                Riverview, FL 33579
              </p>

            </div>
          </div>
        </div>
      </footer>
    </>
  );
};


export default SiteFooter;
